const processSrc = (src) => {
  if (src?.startsWith("cdn")) {
    return `https://${src}`; // Prepend https:// to make it absolute
  }
  return src; // Return the original src if it's already absolute
};

export default processSrc;
